export default __webpack_public_path__ + "static/media/rewards.559ddb7f.svg";